export const SITE_URL = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");
export const ALLOW_INDEX = process.env.REACT_APP_ALLOW_INDEXING === "true";
export const abs = (p = "/") => (p.startsWith("http") ? p : SITE_URL + p);
export const LOGO = "/brand/shadc-logo-512.png";

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: abs(it.path) })),
});

export const faqLd = (faqs = []) =>
  faqs.length
    ? {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
      }
    : null;

export const businessLd = (s) =>
  s && {
    "@context": "https://schema.org",
    "@type": "Store",
    "@id": abs("/#business"),
    name: s.name,
    url: abs("/"),
    logo: abs(LOGO),
    image: abs(LOGO),
    telephone: s.phone,
    email: s.email,
    address: {
      "@type": "PostalAddress",
      streetAddress: s.address.street,
      addressLocality: s.address.city,
      addressRegion: s.address.region,
      postalCode: s.address.postal,
      addressCountry: s.address.country,
    },
    openingHours: s.hours_schema,
    areaServed: { "@type": "City", name: "Washington, DC" },
  };

export const websiteLd = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "SHADC Dispensary",
  url: abs("/"),
  potentialAction: {
    "@type": "SearchAction",
    target: { "@type": "EntryPoint", urlTemplate: abs("/shop/?q={search_term_string}") },
    "query-input": "required name=search_term_string",
  },
});
